import { useGetOperationalStatus } from '@shared/features/operational-status/hooks/useGetOperationalStatus.ts';

const OperationalState = () => {
    const { isLoading, data } = useGetOperationalStatus('26f640b3-86e5-4bfe-ac41-e4a79373ff98');
    if (isLoading || data?.overallStatus.isOperationalState) return <></>;
    return (
        <div id='alert'>
            <div
                className='alert alert-danger mb-0'
                role='alert'
            >
                <div className='container-md'>
                    <div className='row justify-content-center'>
                        <div className='d-flex flex-wrap'>
                            <div>
                                <span className='mdi mr-2'>
                                    <svg
                                        viewBox='0 0 24 24'
                                        style={{ height: '24px', width: '24px' }}
                                    >
                                        <path
                                            fill='currentColor'
                                            d='M11,15H13V17H11V15M11,7H13V13H11V7M12,2C6.47,2 2,6.5 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20Z'
                                        ></path>
                                    </svg>
                                </span>
                            </div>
                            <div className='flex-1'>
                                {' '}
                                <h5 className='alert-heading'>Driftstörningar på Mina Sidor</h5>
                                <p>
                                    Just nu pågår det driftstörningar, vilket gör att visa delar av appen inte fungerar som de ska.
                                    <br />
                                    Vid akuta frågor kontakta oss på:{' '}
                                    <a
                                        href='tel:010-480 30 00'
                                        className='text-nowrap'
                                    >
                                        010-480 30 00
                                    </a>
                                    .
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OperationalState;
